import { FC } from "react";

import MultisiteContent from "../multi_sites/MultiSiteContent";
import OAuthResponseDialog from "../o_auth/OAuthResponseDialog";

interface IPageContent {
  content: React.ReactNode;
}
//The responsibility of this component is to render the content of the page
const MultisiteContentPageRouter: FC<IPageContent> = ({ content }) => {
  return (
    <>
      <OAuthResponseDialog />
      <MultisiteContent>{content}</MultisiteContent>
    </>
  );
};

export default MultisiteContentPageRouter;
